import styled from 'styled-components';
import { Checkbox } from 'evergreen-ui';

const StyledCheckbox = styled(Checkbox)`
  display: flex;
  align-items: center;
  user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;

  svg {
    opacity: 0;
  }
  input[type='checkbox']:not([disabled]):checked + div > svg {
    opacity: 1;
  }
  input[type='checkbox']:not([disabled]):checked:hover + div {
    background-color: #e78850 !important;
  }
  & > div {
    width: 30px;
    height: 30px;
    border: none;
    box-shadow: none;
    color: #a7aaac;
    border-radius: 8px;
    background-color: #2b2d2e;
  }
  & > span {
    color: #a7aaac;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 1.45;
    & > a {
      color: #e78850;
      text-decoration: none;
    }
  }
`;

export default StyledCheckbox;
